import React from 'react';

import Link from '../../library/link/link';
import StarRating, { RatingLink } from '../../library/star-rating/star-rating';

import './product-rating.scss';

interface ProductRatingProps {
  avgReviewRating: number;
  className?: string;
  hideRating?: boolean;
  link?: string;
  linkText?: string;
  numberOfReviews: number;
  onReadReviewClick: () => void;
  productCode?: string | null;
  rearProductCode?: string | null;
  showCompareReviews?: boolean;
  showCount?: boolean;
}

function ProductRating(props: ProductRatingProps) {
  const {
    avgReviewRating,
    className = '',
    hideRating = false,
    link,
    linkText,
    numberOfReviews,
    onReadReviewClick,
    productCode,
    rearProductCode,
    showCompareReviews,
    showCount = true
  } = props;

  return (
    <div
      className={`product-rating ${className}`}
      data-testid="product-rating"
      styleName="reviews"
    >
      <StarRating
        hideRating={hideRating}
        rating={avgReviewRating}
        styleName="star-rating"
      />
      <RatingLink
        className="rating-link"
        count={numberOfReviews}
        defaultText="No reviews yet"
        href={link}
        linkText={linkText}
        onClick={onReadReviewClick}
        showCount={showCount}
      />
      {showCompareReviews && (
        <Link
          className="rating-link"
          to={`/review/product/comparison?allVehicles=true&productCode=${productCode}${
            rearProductCode ? `&rearProductCode=${rearProductCode}` : ''
          }`}
        >
          Compare Reviews
        </Link>
      )}
    </div>
  );
}

export default ProductRating;
